module.exports = __webpack_public_path__ + "img/withdraw-text.296a4315.png";